import { Box, RadioButton, Text } from '@origin-digital/style-guide';
import * as React from 'react';
import analytics from '../../../../analytics';
import FieldError from '../../Layout/FieldError';

import { RadioGroupProps } from './RadioGroup.types';
import SolarIcon from '../../../../components/SolarIcon';

class RadioGroup extends React.Component<RadioGroupProps, {}> {
  constructor(props: RadioGroupProps) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
  }

  componentDidUpdate() {
    const { disqualificationHandler, helpers, name } = this.props;

    if (disqualificationHandler) {
      disqualificationHandler(name, helpers.form);
    }
  }

  onSelect = (value: string): void => {
    const { helpers, changeHandler, name } = this.props;

    if (helpers.form.values[name] !== value) {
      helpers.form.setFieldValue(name, value, true);
      helpers.form.setFieldTouched(name, true, true);

      if (changeHandler) {
        changeHandler({ [name]: value });
      }
    }

    analytics.radioSelect(name, value);
  };

  render(): JSX.Element | null {
    const { name, options, maxWidth, helpers, isDisqualified } = this.props;
    const { form } = helpers;
    const hasError = (form.errors[name] && !isDisqualified) || false;

    return (
      <React.Fragment>
        <Box
          direction="row"
          display={'block'}
          flex="grow"
          maxWidth={maxWidth || 500}
          flexWrap={true}
          marginBottom={3}
        >
          {options.map((option, i) => {
            const checked = form.values[name] === option.value;
            return (
              <Box
                key={`${i}${option.value}`}
                data-id={option.value}
                padding={4}
                onClick={() => this.onSelect(option.value)}
              >
                <RadioButton
                  helpText={option.byline}
                  name={name}
                  checked={checked}
                  label={
                    option.icon ? (
                      <Box alignItems="center" direction="row" display="flex">
                        <Box marginRight={4}>
                          <SolarIcon iconType={option.icon} />
                        </Box>
                        <Text size={'sm'}>{option.label}</Text>
                      </Box>
                    ) : (
                      option.label
                    )
                  }
                  onClick={() => {}}
                />
              </Box>
            );
          })}
        </Box>
        {hasError && (
          <Box marginLeft={3}>
            <FieldError name={name} error={name} />
          </Box>
        )}
      </React.Fragment>
    );
  }
}

export { RadioGroup as default };
